import { AlertProps as MuiAlertProps } from '@mui/material/Alert'

export interface AlertProps extends MuiAlertProps {
  variant?: Exclude<MuiAlertProps['variant'], 'filled'>
}
